var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRouteRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00914 2.17268C7.51211 1.67565 7.51211 0.869804 8.00914 0.372773C8.50617 -0.124258 9.31201 -0.124258 9.80904 0.372773L13.6272 4.19095C13.7493 4.31299 13.8413 4.45364 13.9034 4.60376C13.9657 4.75382 14 4.91835 14 5.09091C14 5.26348 13.9657 5.42802 13.9034 5.57809C13.8415 5.72777 13.7498 5.86804 13.6283 5.98982C13.6279 5.9902 13.6275 5.99058 13.6271 5.99095L9.80904 9.80905C9.31201 10.3061 8.50617 10.3061 8.00914 9.80905C7.51211 9.31201 7.51211 8.50617 8.00914 8.00914L9.65464 6.36364H6.36364C4.25496 6.36364 2.54545 8.07314 2.54545 10.1818V12.7273C2.54545 13.4302 1.97564 14 1.27273 14C0.569819 14 0 13.4302 0 12.7273V10.1818C0 6.66733 2.84915 3.81818 6.36364 3.81818H9.65464L8.00914 2.17268Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRouteRight);
export default __webpack_public_path__ + "static/media/icon-route-right.4a68214fec9541c389d9ea111fadcd3d.svg";
export { ForwardRef as ReactComponent };